import React from 'react';
import PropTypes from 'prop-types';
import Card from '@welldev-group/rcl-card';
import Alert from '@welldev-group/rcl-alert';
import SanitizedHTML from '../../../../../../shared/components/SanitizedHTML';
import VerificationHeader from './VerificationHeader';
import VerificationRadioGroup from './VerificationRadioGroup';
import verificationHelper from './verificationHelper';

const VerificationContent = ({ affiliateId }) => {
  const {
    status,
    initialStatus,
    isEditing,
    isSaving,
    isLoading,
    error,
    handleEdit,
    handleCancel,
    handleSave,
    handleStatusChange,
    handleClearError,
  } = verificationHelper(affiliateId);

  return (
    <Card version="v2">
      <div className="affiliate-config-verification">
        <Alert
          className="affiliate-config-verification__alert"
          isVisible={!!error}
          type="danger-light"
          onClose={handleClearError}
        >
          {error}
        </Alert>

        <VerificationHeader
          status={status}
          isLoading={isLoading}
          isEditing={isEditing}
          isSaving={isSaving}
          initialStatus={initialStatus}
          onEdit={handleEdit}
          onCancel={handleCancel}
          onSave={handleSave}
        />

        <div className="affiliate-config-verification__description">
          <SanitizedHTML
            html={I18n.t(
              'components.affiliate_three_sixty.affiliate.configuration.affiliate_verification.description_html',
            )}
          />
        </div>

        <VerificationRadioGroup
          status={status}
          isEditing={isEditing}
          onStatusChange={handleStatusChange}
        />
      </div>
    </Card>
  );
};

VerificationContent.propTypes = {
  affiliateId: PropTypes.number.isRequired,
};

export default VerificationContent;
